import {Component, EventEmitter, Input, OnInit, Output, NgZone} from '@angular/core';
import {BillingStatus, UserBilling} from '../../../../../models/Billing/billing-details';
import {Currency} from '../../../../../models/Billing/currency';
import {CommonConstant} from '../../../../app.constants';
import {UserService} from '../../../../services/user.service';
import {AppSettings} from '../../../../utils/app-settings';
import {TranslateService} from '@ngx-translate/core';
import { CompanyStatus } from '../../../../../models/common';

@Component({
  selector: 'account-type',
  templateUrl: './account-type.component.html',
  styleUrls: ['./account-type.component.scss']
})
export class AccountTypeComponent implements OnInit {
  @Input() userBilling: UserBilling;
  @Input() shouldReloadPage: boolean;
  @Output() afterUpdateSubscription: EventEmitter<any> = new EventEmitter();
  @Output() requestReloadBilling = new EventEmitter();

  private symbolCurrencies: Currency[] = [
    {
      id: 1,
      name: CommonConstant.EUROPE_CURRENCY,
      code: CommonConstant.EUROPE_CURRENCY,
      symbol: CommonConstant.CURRENCY_SIGN.EURO
    },
    {
      id: 2,
      name: CommonConstant.US_CURRENCY,
      code: CommonConstant.US_CURRENCY,
      symbol: CommonConstant.CURRENCY_SIGN.USD
    },
    {
      id: 3,
      name: CommonConstant.POUND_CURRENCY_CODE,
      code: CommonConstant.POUND_CURRENCY_CODE,
      symbol: CommonConstant.CURRENCY_SIGN.POUND
    }
  ];
  private cbInstance;
  constructor(private userService: UserService, private translate: TranslateService, private _ngZone: NgZone) {
  }

  ngOnInit() {
    if (typeof window['Chargebee'] === 'function') {
      this.cbInstance = window['Chargebee'].init({
        site: AppSettings.cbSite()
      });
      this.cbInstance.setPortalSession(() => {
        return this.userService.getPortalSession(this.userService.getCompanyId()).toPromise();
      });
    }
  }

  get canShowInvoicedNextMonth() {
    return this.userBilling && !this.userBilling.isLoading && this.userBilling.currency;
  }

  get canEditSubscription() {
    return this.userBilling && !this.userBilling.isLoading
      && this.userService.isAgency
      && this.userBilling.canManageSubscription;
  }

  get hasValidSubscription() {
    if (this.userService.isFreeUser()) {
      return true;
    }
    return this.userBilling && !this.userBilling.isLoading
      && (this.userBilling.status !== BillingStatus.IN_TRIAL || this.userBilling.isValidPayment);
  }

  get canViewSubscriptionId() {
    return this.userBilling && !this.userBilling.isLoading
      && this.userService.isAdmin;
  }

  get isAccountInactive() {
    return this.userBilling
      && (this.userBilling.customerStatus === CompanyStatus.BLOCKED || this.userBilling.customerStatus === CompanyStatus.CHURNED);
  }

  get isFutureAccount() {
    return this.userBilling && this.userBilling.customerStatus === CompanyStatus.FUTURE;
  }

  checkoutSubscription() {
    const companyId = this.userService.getCompanyId();
    this.cbInstance.openCheckout({
      hostedPage: () => {
        return this.userService.generateCheckoutNewSubscription(companyId).toPromise();
      },
      layout: 'full_page',
      error: (error) => {
        this.afterUpdateSubscription.emit({
          isError: true,
          message: this.translate.instant('user_billing.checkout_subscription_error')
        });
      },
      success: (hostedPageId) => {
        // Call WS to retrieve the updated subscription data after paying success
        this.loadBillingData();
      }
    });
  }

  openCustomerPortal() {
    this.cbInstance.createChargebeePortal().open({
      error: (err) => {
        this.afterUpdateSubscription.emit({
          isError: true,
          message: this.translate.instant('user_billing.open_customer_portal_error')
        });
      },
      close: () => {
        // Call WS to retrieve the updated subscription data
        this.loadBillingData();
      }
    });
  }

  getCurrencySymbol(currencyCode) {
    const currency = this.symbolCurrencies.find(sc => sc.code === currencyCode);
    return currency ? currency : currencyCode;
  }

  private loadBillingData(): void {
    // this function is invoked by third-party library so nothing guarentee Angular detect changes immediately
    // using ngZone.run to make sure changeDetection work for it
    this._ngZone.run(() => {
      this.requestReloadBilling.emit();
      this.userService.triggerUpdateActivatedInfluencers();
    });
  }

  public reloadPage(): void {
    window.location.reload();
  }
}



// WEBPACK FOOTER //
// ./src/app/main/user/user-billing/account-type/account-type.component.ts